import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DeleteAskAIAnswerApiParams } from '../apis';

import { clientAxios } from '@/shared/api';
import { ApiResponse } from '@/shared/types';

const useDeleteAskAIAnswerMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ questionHashKey }: DeleteAskAIAnswerApiParams) =>
      clientAxios.delete<ApiResponse<unknown>>('/deleteAskAIAnswerApi/', {
        data: { questionHashKey },
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['askAI', 'questions'],
      });
    },
  });
};

export default useDeleteAskAIAnswerMutation;
